module.exports = __webpack_public_path__ + "img/notification.3141973c.svg";